import {formatPrice,formatPriceRev} from "./logic";

class Schulden {
    /**
     *
     * @param schulden
     * @param monate
     */
    constructor(
        schulden = 0,
        monate = 12,
        )
    {
        this.schulden = Number(schulden);
        this.monate = Number(monate);
    }
    get berechnung(){
        return this.berechneSchulden();
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }

    /**
     * Schulden berechnen
     * @returns {number}
     */
    berechneSchulden(){
        let betrag = 0.00
        betrag += (this.schulden / this.monate)
        return betrag;
    }
}

function schuldenBerechnen($this, aus = false){
    if(aus) { // nullen
        const nu = new Schulden();
        $this.el$('results.schulden').value = nu.null
        //console.log('Schulden aus: nullen')
    }else{
        // Schulden berechnen
        //console.log('Schulden an: berechnen')
        let abzug = 0.00
        if($this.el$('Schulden.art').value === 'ja'){ // Schulden vorhanden
            //console.log('schulden vorhanden?: ja')
            // Werte holen
            const schuld = new Schulden($this.el$('Schulden.schulden').value,12);
            abzug = schuld.berechnung
        }
        //console.log('schulden: '+abzug)
        let vermoegen = 0.00
        if($this.el$('results.vermoegen').value){ // Vermögen gesetzt?
            vermoegen = formatPriceRev($this.el$('results.vermoegen').value)
        }
        if(abzug>vermoegen){
            // Schulden können nur in Höhe des Vermögens angerechnet werden
            abzug = vermoegen
        }
        //console.log('neue schulden: '+abzug)
        $this.el$('results.schulden').value = formatPrice(abzug)
    }
}

/**
 * Funktionen exportieren
 */
export {schuldenBerechnen};
